export default __webpack_public_path__ + "static/media/rocket_anim_81.fcae9637.png";